// extracted by mini-css-extract-plugin
export default {"input":"inputCode_input__XyCww","inputContainer":"inputCode_inputContainer__aBeE9"};